import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "@xo-union/tk-component-icons";
import classesPropType from "@xo-union/classes-prop-type";
import { useButtonClasses } from "../ThemeContext.js";
var CtaContainer = function CtaContainer(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    iconName = _ref.iconName,
    labelDirection = _ref.labelDirection,
    size = _ref.size;
  var classes = useButtonClasses(classesProp);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes['cta-container'], iconName && classes["has-".concat(labelDirection || 'left', "-label")])
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: classes.icon,
    size: size === 'lg' ? 'lg' : 'md',
    "aria-hidden": "true"
  }), children);
};
process.env.NODE_ENV !== "production" ? CtaContainer.propTypes = {
  /**
   * The button's content
   */
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType(['cta-container', 'icon-left', 'icon-right']),
  /**
   * Icon to place next to CTA text.
   */
  iconName: PropTypes.string,
  /**
   * Determines whether the CTA text will be on the left or right side of the icon.
   */
  labelDirection: PropTypes.oneOf(['left', 'right']),
  /**
   * Size class
   * */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
} : void 0;
export default CtaContainer;